module.exports = {
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST: 'RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_REQUEST',
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS: 'RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_SUCCESS',
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE: 'RETRIEVE_OUTBOUND_POSTAL_OPERATOR_MAILBOX_FAILURE',
  DEPARTURE_MAILBOX_CHECKED: 'DEPARTURE_MAILBOX_CHECKED',
  DEPARTURE_POSTAL_OPERATOR_EXPANDED: 'DEPARTURE_POSTAL_OPERATOR_EXPANDED',
  SELECT_ALL_DEPARTURE_MAILBOXES: 'SELECT_ALL_DEPARTURE_MAILBOXES',
  DESELECT_ALL_DEPARTURE_MAILBOXES: 'DESELECT_ALL_DEPARTURE_MAILBOXES',
  DEPARTURE_POSTAL_OPERATOR_EXPANDED_MAILBOX_ADMIN: 'DEPARTURE_POSTAL_OPERATOR_EXPANDED_MAILBOX_ADMIN',
};
